import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 5,
			width: 18,
			height: 14,
			rx: 3,
			fill: "#DBE4E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.385 14.692H6.269V12.616H8.692C8.98867 12.616 9.24234 12.5103 9.453 12.299C9.66367 12.0883 9.769 11.835 9.769 11.539V10.385C9.769 10.089 9.66367 9.83533 9.453 9.624C9.24234 9.41333 8.989 9.308 8.693 9.308H5.384L5.385 14.692ZM11.365 14.692H12.25V9.308H11.365V14.692ZM14.231 14.692H15.058V10.77L17.762 14.693H18.616V9.308H17.789V13.231L15.134 9.308H14.231V14.692ZM6.269 11.731V10.192H8.577C8.65367 10.192 8.72434 10.2243 8.789 10.289C8.85234 10.353 8.884 10.4233 8.884 10.5V11.423C8.884 11.5003 8.852 11.571 8.788 11.635C8.724 11.699 8.65367 11.731 8.577 11.731H6.269ZM4.615 19C4.155 19 3.77067 18.846 3.462 18.538C3.15334 18.23 2.99934 17.8453 3 17.384V6.616C3 6.15533 3.15434 5.771 3.463 5.463C3.77167 5.155 4.15567 5.00067 4.615 5H19.385C19.845 5 20.229 5.15433 20.537 5.463C20.845 5.77167 20.9993 6.156 21 6.616V17.385C21 17.845 20.8457 18.2293 20.537 18.538C20.2283 18.8467 19.8443 19.0007 19.385 19H4.615ZM4.615 18H19.385C19.5383 18 19.6793 17.936 19.808 17.808C19.9367 17.68 20.0007 17.5387 20 17.384V6.616C20 6.462 19.936 6.32067 19.808 6.192C19.68 6.06333 19.539 5.99933 19.385 6H4.615C4.46167 6 4.32067 6.064 4.192 6.192C4.06334 6.32 3.99934 6.46133 4 6.616V17.385C4 17.5383 4.064 17.6793 4.192 17.808C4.32 17.9367 4.461 18.0007 4.615 18Z",
			fill: "#293235"
		})
	]
});
const ForwardRef = forwardRef(SvgPin);
export { ForwardRef as ReactComponent };
